<div class="chat-messages"
     *ngIf="currentThreadId"
     [class.chat-messages--minimal]="displayMode === 'minimal'"
     (click)="closeToolPopover(); closeMinimalToolHistoryPopover(); closeGeneratedImageOptionsPopover(); closeGeneratedAudioOptionsPopover(); closeArtifactSelectorPopover()">
    <ng-container *ngFor="let chat of history; let i = index; trackBy: trackByMessage">
           <div *ngIf="shouldRenderMessage(chat, i)"
               class="message-group"
               [class.message-group--inline-tool]="shouldUseToolLayout(chat)"
               [class.message-group--inline-preview]="shouldUseInlinePreviewLayout(chat, i)"
               [attr.data-message-id]="chat.id || null"
               [attr.data-message-index]="i">
        <div [ngClass]="{
            'message-user': chat.role === 'user', 
            'message-ai': shouldUseAiLayout(chat),
            'message-tool': shouldUseToolLayout(chat),
            'message-tool-compact': shouldUseCompactToolLayout(chat),
            'message-system': chat.role === 'system',
            'message-compaction': isCompactionMarker(chat),
            'message-with-tools': shouldHighlightToolUsage(chat)
        }" class="message">
            <div class="message-content">
                <div *ngIf="isCompactionMarker(chat)"
                     class="message-compaction-divider"
                     [class.message-compaction-divider--interactive]="canOpenCompactionMarker(chat)"
                     [attr.title]="getCompactionMarkerTitle(chat)">
                    <span class="message-compaction-divider__line"></span>
                    <button *ngIf="canOpenCompactionMarker(chat); else readonlyCompactionMarker"
                            type="button"
                            class="message-compaction-divider__label message-compaction-divider__label--button"
                            [attr.aria-label]="getCompactionMarkerAriaLabel(chat)"
                            (click)="openCompactionMarkerDetails(i, $event)">
                        <i class="fa-regular fa-compress"></i>
                        <span>{{ getCompactionMarkerLabel(chat) }}</span>
                    </button>
                    <ng-template #readonlyCompactionMarker>
                        <span class="message-compaction-divider__label">
                            <i class="fa-regular fa-compress"></i>
                            <span>{{ getCompactionMarkerLabel(chat) }}</span>
                        </span>
                    </ng-template>
                    <span class="message-compaction-divider__line"></span>
                </div>

                <!-- Display tool calls with simple display name -->
                <div *ngIf="shouldShowToolCallSummary(chat)" 
                     class="message-text message-text--tool-status message-text--tool-call"
                     [class.message-text--tool-status-consolidated]="shouldShowMinimalToolHistoryTrigger(chat, i)">
                    <button *ngIf="shouldShowMinimalToolHistoryTrigger(chat, i); else toolCallStatusMain"
                            type="button"
                            class="message-text--tool-status-main message-text--tool-status-main-button"
                            [attr.aria-label]="getMinimalToolHistoryAriaLabel(i)"
                            (click)="openMinimalToolHistoryPopover(i, $event)">
                        <i [class]="getToolMessageIconClass(chat)"></i>
                        <span>{{ getToolCallDisplayLabel(chat) }}</span>
                        <i class="fa-regular fa-chevron-right message-text--tool-status-caret"></i>
                    </button>
                    <ng-template #toolCallStatusMain>
                        <div class="message-text--tool-status-main">
                            <i [class]="getToolMessageIconClass(chat)"></i>
                            <span>{{ getToolCallDisplayLabel(chat) }}</span>
                        </div>
                    </ng-template>

                    <button *ngIf="shouldShowInlineToolOptions(chat)"
                            type="button"
                            class="tool-status-options"
                            aria-label="Open tool call details"
                            (click)="toggleToolPopover(i, $event)">
                        <i class="fa-solid fa-ellipsis"></i>
                    </button>
                </div>

                <!-- Display tool result with simple display name -->
                <div *ngIf="shouldShowToolResult(chat)" 
                     class="message-text message-text--tool-status message-text--tool-result"
                     [class.message-text--tool-status-consolidated]="shouldShowMinimalToolHistoryTrigger(chat, i)"
                     [class.message-text--tool-error]="isToolResultFailure(chat)">
                    <button *ngIf="shouldShowMinimalToolHistoryTrigger(chat, i); else toolResultStatusMain"
                            type="button"
                            class="message-text--tool-status-main message-text--tool-status-main-button"
                            [attr.aria-label]="getMinimalToolHistoryAriaLabel(i)"
                            (click)="openMinimalToolHistoryPopover(i, $event)">
                        <i [class]="getToolMessageIconClass(chat)"></i>
                        <span>{{ getToolResultDisplayLabel(chat) }}</span>
                        <i class="fa-regular fa-chevron-right message-text--tool-status-caret"></i>
                    </button>
                    <ng-template #toolResultStatusMain>
                        <div class="message-text--tool-status-main">
                            <i [class]="getToolMessageIconClass(chat)"></i>
                            <span>{{ getToolResultDisplayLabel(chat) }}</span>
                        </div>
                    </ng-template>

                    <button *ngIf="shouldShowInlineToolOptions(chat)"
                            type="button"
                            class="tool-status-options"
                            aria-label="Open tool result details"
                            (click)="toggleToolPopover(i, $event)">
                        <i class="fa-solid fa-ellipsis"></i>
                    </button>
                </div>

                <div *ngIf="shouldShowToolResult(chat) && hasVisiblePreviewBlocks(chat, i)"
                     class="tool-preview-stack">
                    <div *ngFor="let preview of getVisiblePreviewBlocks(chat, i); trackBy: trackByPreview"
                         class="tool-preview-inline"
                         [class.tool-preview-inline--expanded]="shouldRenderInlineAssets()">
                        <div class="tool-preview-inline__header">
                            <div class="tool-preview-inline__copy">
                                <div class="tool-preview-inline__title">{{ preview.title }}</div>
                            </div>

                            <div class="tool-preview-inline__actions">
                                <button *ngIf="shouldRenderInlineAssets()"
                                        type="button"
                                        class="inline-preview-toggle"
                                        [title]="getToolInlinePreviewToggleLabel(preview)"
                                        [attr.aria-label]="getToolInlinePreviewToggleLabel(preview)"
                                        [attr.aria-expanded]="!isToolInlinePreviewCollapsed(preview)"
                                        (click)="toggleToolInlinePreview(preview, $event)">
                                    <i class="fa-solid"
                                       [ngClass]="isToolInlinePreviewCollapsed(preview) ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                                </button>

                                <button type="button"
                                        class="tool-preview-inline__action"
                                        [title]="getToolPreviewActionLabel(preview)"
                                        [attr.aria-pressed]="usesDetachedPreviewSurface() ? isDetachedPreviewActive('tool-preview', preview.id) : null"
                                        (click)="openPreviewModal(preview, $event)">
                                    <i class="fa-solid"
                                       [ngClass]="isDetachedPreviewActive('tool-preview', preview.id) ? 'fa-xmark' : 'fa-expand'"></i>
                                    <span>{{ getToolPreviewActionLabel(preview) }}</span>
                                </button>
                            </div>
                        </div>

                        <div *ngIf="shouldRenderInlinePreview(preview)"
                             class="tool-preview-inline__viewport"
                             [style.height.px]="preview.height">
                            <iframe class="tool-preview-inline__frame"
                                    [src]="preview.safeUrl"
                                    allow="clipboard-write"
                                    frameborder="0"
                                    referrerpolicy="strict-origin-when-cross-origin"></iframe>
                        </div>
                    </div>
                </div>

                <ng-container *ngIf="shouldShowToolResult(chat) && getVisibleArtifactResources(chat, i) as artifacts">
                    <div *ngIf="artifacts.length > 0"
                         class="artifact-strip">
                        <button *ngIf="artifacts.length === 1"
                                type="button"
                                class="artifact-inline__action artifact-inline__action--single"
                                [title]="getArtifactInlineActionLabel(artifacts[0])"
                                [attr.aria-pressed]="usesDetachedPreviewSurface() ? isDetachedPreviewActive('artifact', artifacts[0].id) : null"
                                (click)="openArtifactResource(artifacts[0], $event)">
                            <i class="fa-solid"
                               [ngClass]="isDetachedPreviewActive('artifact', artifacts[0].id) ? 'fa-xmark' : 'fa-file-lines'"></i>
                            <span>{{ getArtifactInlineActionLabel(artifacts[0]) }}</span>
                        </button>

                        <button *ngIf="artifacts.length > 1"
                                type="button"
                                class="artifact-inline__action artifact-inline__action--selector"
                                [class.artifact-inline__action--active-selection]="hasActiveArtifactInSet(artifacts)"
                                [class.artifact-inline__action--open]="isArtifactSelectorOpen(artifacts)"
                                [title]="getArtifactSelectorTitle(artifacts)"
                                [attr.aria-expanded]="isArtifactSelectorOpen(artifacts)"
                                (click)="openArtifactSelectorPopover(artifacts, $event)">
                            <i class="fa-regular fa-files"></i>
                            <span>{{ getArtifactSelectorLabel(artifacts) }}</span>
                            <i class="fa-solid fa-chevron-down"></i>
                        </button>
                    </div>

                    <div *ngIf="shouldRenderInlineArtifacts(artifacts)"
                         class="artifact-inline-preview-list">
                        <ng-container *ngFor="let artifact of artifacts; trackBy: trackByArtifact">
                        <div *ngIf="getInlineArtifactPreviewState(artifact) as inlinePreview"
                             class="artifact-inline-preview-card">
                            <div class="artifact-inline-preview-card__header">
                                <i [class]="getThreadArtifactIconClass(inlinePreview.artifact)"></i>
                                <div class="artifact-inline-preview-card__copy">
                                    <div class="artifact-inline-preview-card__title">{{ inlinePreview.artifact.title }}</div>
                                    <div class="artifact-inline-preview-card__subtitle">{{ inlinePreview.artifact.subtitle || getArtifactLocationLabel(inlinePreview.artifact) }}</div>
                                </div>
                                <button type="button"
                                        class="inline-preview-toggle"
                                        [title]="getArtifactInlinePreviewToggleLabel(inlinePreview.artifact)"
                                        [attr.aria-label]="getArtifactInlinePreviewToggleLabel(inlinePreview.artifact)"
                                        [attr.aria-expanded]="!isArtifactInlinePreviewCollapsed(inlinePreview.artifact)"
                                        (click)="toggleArtifactInlinePreview(inlinePreview.artifact, $event)">
                                    <i class="fa-solid"
                                       [ngClass]="isArtifactInlinePreviewCollapsed(inlinePreview.artifact) ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                                </button>
                                <button *ngIf="shouldShowStandaloneArtifactDelete(inlinePreview.artifact)"
                                        type="button"
                                        class="artifact-inline-preview-card__icon-action artifact-inline-preview-card__icon-action--danger"
                                        [title]="getArtifactDeleteLabel(inlinePreview.artifact)"
                                        [attr.aria-label]="getArtifactDeleteLabel(inlinePreview.artifact)"
                                        [disabled]="!canDeleteArtifactResource(inlinePreview.artifact)"
                                        (click)="deleteArtifactResource(inlinePreview.artifact, chat, i, $event)">
                                    <i class="fa-regular"
                                       [ngClass]="isArtifactResourceDeleting(inlinePreview.artifact) ? 'fa-spinner fa-spin' : 'fa-trash-can'"></i>
                                </button>
                                <button type="button"
                                        class="artifact-inline-preview-card__action"
                                        (click)="openArtifactResource(inlinePreview.artifact, $event)">
                                    <i class="fa-regular fa-up-right-from-square"></i>
                                    <span>{{ getArtifactPreviewActionLabel(inlinePreview.artifact) }}</span>
                                </button>
                            </div>

                            <ng-container *ngIf="!isArtifactInlinePreviewCollapsed(inlinePreview.artifact)">
                            <div *ngIf="inlinePreview.loading" class="artifact-preview-state artifact-preview-state--compact">
                                <div class="artifact-preview-state__loader" aria-hidden="true">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                                <div class="artifact-preview-state__copy">
                                    <strong>Loading preview</strong>
                                    <span>Preparing the artifact view.</span>
                                </div>
                            </div>

                            <div *ngIf="!inlinePreview.loading && inlinePreview.error" class="artifact-preview-state artifact-preview-state--error">
                                <i class="fa-regular fa-file-circle-xmark"></i>
                                <span>{{ inlinePreview.error }}</span>
                            </div>

                            <ng-container *ngIf="!inlinePreview.loading && !inlinePreview.error && inlinePreview.preview as preview">
                                <div class="artifact-preview-notice" *ngIf="preview.truncated">
                                    Showing a truncated preview of {{ preview.sizeBytes | number }} bytes.
                                </div>

                                <div *ngIf="preview.type === 'markdown'"
                                     class="artifact-preview-markdown artifact-preview-markdown--inline"
                                     [innerHTML]="parseMarkdown(preview.content)">
                                </div>

                                <div *ngIf="preview.type === 'csv'" class="artifact-preview-csv">
                                    <div *ngIf="getArtifactPreviewRowsFor(preview).length === 0" class="artifact-preview-state">
                                        <span>This CSV is empty.</span>
                                    </div>

                                    <div *ngIf="getArtifactPreviewRowsFor(preview).length > 0" class="artifact-preview-table-wrap">
                                        <table class="artifact-preview-table">
                                            <thead>
                                                <tr>
                                                    <th *ngFor="let cell of getArtifactPreviewHeaderFor(preview)">{{ cell }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let row of getArtifactPreviewBodyFor(preview)">
                                                    <td *ngFor="let cell of row">{{ cell }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <pre *ngIf="preview.type === 'text'"
                                     class="artifact-preview-text artifact-preview-text--inline"><code>{{ preview.content }}</code></pre>

                                <div *ngIf="preview.type === 'html' || preview.type === 'svg'" class="artifact-preview-html-stage artifact-preview-html-stage--inline">
                                    <app-html-previewer [html]="preview.content"
                                                         [baseUrl]="preview.fileUrl || null">
                                    </app-html-previewer>
                                </div>

                                <div *ngIf="preview.type === 'image'" class="artifact-preview-image-wrap">
                                    <img *ngIf="preview.fileUrl"
                                         class="artifact-preview-image"
                                         [src]="preview.fileUrl"
                                         [alt]="inlinePreview.artifact.title || 'Artifact preview'">
                                </div>

                                <div *ngIf="preview.type === 'audio'" class="artifact-preview-media-wrap">
                                    <audio *ngIf="preview.fileUrl"
                                           class="artifact-preview-audio"
                                           controls
                                           preload="metadata"
                                           [src]="preview.fileUrl">
                                    </audio>
                                </div>

                                <div *ngIf="preview.type === 'video'" class="artifact-preview-media-wrap">
                                    <video *ngIf="preview.fileUrl"
                                           class="artifact-preview-video"
                                           controls
                                           preload="metadata"
                                           [src]="preview.fileUrl">
                                    </video>
                                </div>

                                <app-artifact-zip-preview *ngIf="preview.type === 'zip'"
                                                          [archiveTitle]="inlinePreview.artifact.title || 'ZIP archive'"
                                                          [archiveUrl]="preview.fileUrl || null"
                                                          [archiveStorageUri]="inlinePreview.artifact.storageUri || null"
                                                          [detachedPreview]="false"
                                                          [parseMarkdown]="parseMarkdown"
                                                          (archiveDeleted)="onZipArtifactDeleted(inlinePreview.artifact, chat, i, $event)">
                                </app-artifact-zip-preview>

                                <div *ngIf="preview.type === 'file'" class="artifact-preview-file-card">
                                    <i [class]="getThreadArtifactIconClass(inlinePreview.artifact)"></i>
                                    <div class="artifact-preview-file-card__copy">
                                        <strong>{{ inlinePreview.artifact.title }}</strong>
                                        <span>{{ inlinePreview.artifact.subtitle || getArtifactLocationLabel(inlinePreview.artifact) }}</span>
                                    </div>
                                    <a *ngIf="preview.fileUrl"
                                       class="artifact-preview-file-card__link"
                                       [href]="preview.fileUrl"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Open
                                    </a>
                                </div>
                            </ng-container>
                            </ng-container>
                        </div>
                        </ng-container>
                    </div>
                </ng-container>

                <div *ngIf="getMessageGeneratedImages(chat).length > 0"
                     class="message-generated-image-stack">
                    <div *ngFor="let media of getMessageGeneratedImages(chat); trackBy: trackByGeneratedMedia"
                         class="message-generated-image-item">
                        <button type="button"
                                class="message-generated-image-button"
                                [class.message-generated-image-button--detached-active]="isDetachedPreviewActive('generated-image', getGeneratedImagePreviewId(media))"
                                [attr.aria-label]="media.name || 'Preview generated image'"
                                (click)="openGeneratedImagePreview(media, $event)">
                            <div class="message-generated-image-frame">
                                <img class="message-generated-image-thumb"
                                     [src]="media.url"
                                     [alt]="media.name || 'Generated image'" />
                            </div>
                        </button>

                        <div class="message-generated-image-meta">
                            <div class="message-generated-image-name">{{ media.name || 'Generated image' }}</div>
                            <div *ngIf="getGeneratedImageCardDetail(media) as detail" class="message-generated-image-source">{{ detail }}</div>

                            <div class="message-generated-image-actions">
                                <button type="button"
                                        class="message-generated-image-menu-toggle"
                                        [class.message-generated-image-menu-toggle--open]="isGeneratedImageMenuOpen(media)"
                                        [attr.aria-expanded]="isGeneratedImageMenuOpen(media)"
                                        [attr.aria-label]="'Image options for ' + (media.name || 'generated image')"
                                        (click)="openGeneratedImageOptionsPopover(media, $event)">
                                    <span>Options</span>
                                    <i class="fa-solid fa-chevron-down"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="getMessageGeneratedAudio(chat).length > 0 && !shouldUseToolLayout(chat)"
                     class="message-generated-audio-stack">
                    <div *ngFor="let media of getMessageGeneratedAudio(chat); trackBy: trackByGeneratedMedia"
                         class="message-generated-audio-card">
                        <audio #audioPlayer
                               class="message-generated-audio-element"
                               [src]="media.url"
                               preload="metadata"
                               playsinline
                               (loadedmetadata)="onGeneratedAudioMetadataLoaded(media, audioPlayer)"
                               (durationchange)="onGeneratedAudioMetadataLoaded(media, audioPlayer)"
                               (timeupdate)="onGeneratedAudioTimeUpdate(media, audioPlayer)"
                               (play)="onGeneratedAudioPlaybackStateChange(media, audioPlayer, true)"
                               (pause)="onGeneratedAudioPlaybackStateChange(media, audioPlayer, false)"
                               (ended)="onGeneratedAudioEnded(media, audioPlayer)"
                               (ratechange)="onGeneratedAudioRateChange(media, audioPlayer)"
                               (error)="onGeneratedAudioLoadError(media)"></audio>

                        <div class="message-generated-audio-player">
                            <div class="message-generated-audio-controls">
                                <button
                                    type="button"
                                    class="message-generated-audio-play-toggle"
                                    [attr.aria-label]="isGeneratedAudioPlaying(media) ? 'Pause audio' : 'Play audio'"
                                    (click)="toggleGeneratedAudioPlayback(media, audioPlayer)">
                                    <i class="fa-solid" [class.fa-pause]="isGeneratedAudioPlaying(media)" [class.fa-play]="!isGeneratedAudioPlaying(media)"></i>
                                </button>

                                <div class="message-generated-audio-timeline">
                                    <div class="message-generated-audio-time-row">
                                        <span>{{ formatGeneratedAudioTime(getGeneratedAudioCurrentTime(media)) }}</span>
                                        <span>{{ getGeneratedAudioDurationLabel(media) }}</span>
                                    </div>

                                    <input
                                        type="range"
                                        class="message-generated-audio-scrubber"
                                        min="0"
                                        step="0.01"
                                        [max]="getGeneratedAudioDuration(media) || 1"
                                        [value]="getGeneratedAudioCurrentTime(media)"
                                        [disabled]="!hasGeneratedAudioDuration(media)"
                                        [style.--audio-progress]="getGeneratedAudioProgressPercent(media)"
                                        [attr.aria-label]="'Seek ' + (media.name || 'generated audio')"
                                        (input)="onGeneratedAudioSeek(media, audioPlayer, $any($event.target).value)">
                                </div>
                            </div>
                        </div>

                        <div class="message-generated-audio-meta">
                            <div class="message-generated-audio-name">{{ media.name || 'Generated audio' }}</div>

                            <div class="message-generated-audio-options">
                                <button
                                    type="button"
                                    class="message-generated-audio-menu-toggle"
                                    [class.message-generated-audio-menu-toggle--open]="isGeneratedAudioMenuOpen(media)"
                                    [attr.aria-expanded]="isGeneratedAudioMenuOpen(media)"
                                    [attr.aria-label]="'Audio options for ' + (media.name || 'generated audio')"
                                    (click)="openGeneratedAudioOptionsPopover(media, audioPlayer, $event)">
                                    <span>Options</span>
                                    <i class="fa-solid fa-chevron-down"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="getMessageContextAttachments(chat).length > 0 && !shouldUseToolLayout(chat)"
                     class="message-context-strip">
                    <div *ngFor="let attachment of getMessageContextAttachments(chat); trackBy: trackByContextAttachment"
                         class="message-context-chip"
                         [attr.title]="getContextAttachmentTooltip(attachment)">
                        <i [class]="getContextAttachmentIconClass(attachment)"></i>

                        <div class="message-context-chip__copy">
                            <div class="message-context-chip__label">{{ attachment.displayName }}</div>
                            <div class="message-context-chip__meta">{{ getContextAttachmentTypeLabel(attachment) }}</div>
                        </div>
                    </div>
                </div>

                <div *ngIf="getMessageImageAttachments(chat).length > 0 && !shouldUseToolLayout(chat)"
                     class="message-image-strip">
                    <a *ngFor="let attachment of getMessageImageAttachments(chat); trackBy: trackByImageAttachment"
                       class="message-image-link"
                       [href]="attachment.url"
                       target="_blank"
                       rel="noopener noreferrer"
                       [attr.aria-label]="attachment.name || 'Open attached image'">
                        <img class="message-image-thumb"
                             [src]="attachment.url"
                             [alt]="attachment.name || 'Attached image'" />
                    </a>
                </div>
                
                <!-- Display regular content (non-tool messages) -->
                <div *ngIf="isEditingMessage(chat, i); else renderedMessageText"
                     class="message-editor"
                     (click)="$event.stopPropagation()">
                    <textarea class="message-editor__textarea"
                              [value]="editingMessageDraft"
                              rows="8"
                              spellcheck="false"
                              autocapitalize="off"
                              autocomplete="off"
                              autocorrect="off"
                              aria-label="Edit message markdown"
                              (input)="onEditingMessageDraftInput($event)"
                              (keydown.escape)="onCancelEditMessage($event)"
                              (keydown.control.enter)="onSaveEditMessage(i, chat, $event)"
                              (keydown.meta.enter)="onSaveEditMessage(i, chat, $event)"></textarea>

                    <div class="message-editor__actions">
                        <button type="button"
                                class="message-editor__action"
                                (click)="onCancelEditMessage($event)">
                            <i class="fa-solid fa-xmark"></i>
                            <span>Cancel</span>
                        </button>

                        <button type="button"
                                class="message-editor__action message-editor__action--primary"
                                [disabled]="!canSaveEditedMessage(chat)"
                                (click)="onSaveEditMessage(i, chat, $event)">
                            <i class="fa-solid fa-check"></i>
                            <span>Save</span>
                        </button>
                    </div>
                </div>

                <ng-template #renderedMessageText>
                    <div *ngIf="getMessageText(chat) && !shouldUseToolLayout(chat) && !isCompactionMarker(chat)"
                         [innerHTML]="(chat.role === 'model' || chat.role === 'assistant') ? parseMarkdown(getMessageText(chat)) : getMessageText(chat)"
                         class="message-text">
                    </div>
                </ng-template>

                <div *ngIf="shouldShowMessageAnnotationControls(chat, i)"
                     class="message-annotation-controls"
                     [class.message-annotation-controls--saving]="isMessageAnnotationSaving(chat, i)">
                    <div class="message-annotation-controls__ratings" aria-label="Annotate response">
                        <button type="button"
                                class="message-annotation-controls__button message-annotation-controls__button--thumb-up"
                                [class.is-active]="isMessageThumbAnnotationActive(chat, i, 'up')"
                                [disabled]="isMessageAnnotationSaving(chat, i)"
                                title="Annotate thumbs up"
                                aria-label="Annotate thumbs up"
                                (click)="onMessageThumbAnnotation(chat, i, 'up', $event)">
                            <i [class]="isMessageThumbAnnotationActive(chat, i, 'up') ? 'fa-solid fa-thumbs-up' : 'fa-regular fa-thumbs-up'"></i>
                        </button>
                        <button type="button"
                                class="message-annotation-controls__button message-annotation-controls__button--thumb-down"
                                [class.is-active]="isMessageThumbAnnotationActive(chat, i, 'down')"
                                [disabled]="isMessageAnnotationSaving(chat, i)"
                                title="Annotate thumbs down"
                                aria-label="Annotate thumbs down"
                                (click)="onMessageThumbAnnotation(chat, i, 'down', $event)">
                            <i [class]="isMessageThumbAnnotationActive(chat, i, 'down') ? 'fa-solid fa-thumbs-down' : 'fa-regular fa-thumbs-down'"></i>
                        </button>
                        <span class="message-annotation-controls__stars" role="group" aria-label="Annotate star rating">
                            <button *ngFor="let rating of [1, 2, 3, 4, 5]"
                                    type="button"
                                    class="message-annotation-controls__star"
                                    [class.is-active]="isMessageStarAnnotationActive(chat, i, rating)"
                                    [disabled]="isMessageAnnotationSaving(chat, i)"
                                    [attr.aria-label]="'Annotate ' + rating + ' out of 5 stars'"
                                    [title]="rating + ' stars'"
                                    (click)="onMessageStarAnnotation(chat, i, rating, $event)">
                                <i [class]="isMessageStarAnnotationActive(chat, i, rating) ? 'fa-solid fa-star' : 'fa-regular fa-star'"></i>
                            </button>
                        </span>
                    </div>

                    <button type="button"
                            class="message-annotation-controls__note"
                            [class.is-active]="hasMessageNoteAnnotation(chat, i)"
                            [disabled]="isMessageAnnotationSaving(chat, i)"
                            title="Add annotation note"
                            aria-label="Add annotation note"
                            (click)="openMessageNoteAnnotation(chat, i, $event)">
                        <i [class]="getMessageNoteAnnotationIcon(chat, i)"></i>
                        <span>Note</span>
                    </button>

                    <span class="message-annotation-controls__status" *ngIf="isMessageAnnotationSaving(chat, i)">
                        <i class="fa-solid fa-circle-notch fa-spin"></i>
                    </span>
                    <span class="message-annotation-controls__status message-annotation-controls__status--saved" *ngIf="isMessageAnnotationSaved(chat, i)">
                        Saved
                    </span>
                    <span class="message-annotation-controls__status message-annotation-controls__status--error" *ngIf="hasMessageAnnotationError(chat, i)">
                        Failed
                    </span>
                </div>

                <div *ngIf="shouldShowSuggestedFollowUps(chat, i)"
                     class="suggested-follow-ups">
                    <div class="suggested-follow-ups__label">Suggested follow-ups</div>

                    <button *ngFor="let followUp of getSuggestedFollowUps(chat); trackBy: trackBySuggestedFollowUp"
                            type="button"
                            class="suggested-follow-ups__item"
                            (click)="onSuggestedFollowUpClick(followUp, $event)">
                        <span class="suggested-follow-ups__text">{{ followUp }}</span>
                        <i class="fa-solid fa-arrow-right suggested-follow-ups__icon"></i>
                    </button>
                </div>
                
                <div class="message-footer" *ngIf="shouldShowMessageFooter(chat)">
                    <!-- Message role with tool ellipsis -->
                    <div class="message-role-container">
                        <div class="message-role">{{ getMessageRoleLabel(chat) }}</div>
                        
                        <!-- Unified vertical ellipsis for all messages that have details -->
                        <div *ngIf="shouldShowMessageOptions(chat)" 
                             class="tool-ellipsis"
                             (click)="toggleToolPopover(i, $event)">
                            <i class="fas fa-ellipsis-vertical"></i>
                        </div>
                    </div>

                    <div class="message-footer-actions">
                        <button *ngIf="shouldShowEditButton(chat)"
                                type="button"
                                class="message-debug-action message-edit-btn"
                                (click)="onStartEditMessage(i, chat, $event)"
                                title="Edit message markdown"
                                aria-label="Edit message markdown">
                            <i class="fas fa-pen"></i>
                        </button>

                        <!-- Delete button -->
                        <button *ngIf="shouldShowDeleteButton()"
                                type="button" 
                                class="message-debug-action message-delete-btn"
                                (click)="onDeleteMessage(i, chat.id, $event)"
                                title="Delete message"
                                aria-label="Delete message">
                            <i class="fas fa-trash-can"></i>
                        </button>
                    </div>
                </div>
            </div>
            
            <!-- Timestamp outside the bubble -->
            <div class="message-timestamp" 
                 [ngClass]="{
                    'timestamp-user': chat.role === 'user',
                    'timestamp-ai': chat.role === 'model' || chat.role === 'assistant' || chat.role === 'tool' || chat.role === 'system'
                 }"
                 *ngIf="shouldShowTimestamp(chat)">
                {{ formatMessageTime(chat.createdAt) }}<span class="timestamp-delta" *ngIf="displayMode === 'debug' && getTimeDifference(i)"> ({{ getTimeDifference(i) }})</span>
            </div>
        </div>
        </div>
    </ng-container>

    <ng-template #messageDetailsTemplate>
        <div class="message-details-modal" *ngIf="activeMessage">
            <div class="message-details-popover-body">
                <div class="message-details-tabs" *ngIf="getActiveMessageDetailTabs() as detailTabs">
                    <button *ngFor="let tab of detailTabs"
                            type="button"
                            class="message-details-tabs__button"
                            [class.message-details-tabs__button--active]="isActiveMessageDetailsTab(tab.id)"
                            (click)="selectActiveMessageDetailsTab(tab.id, $event)">
                        {{ tab.label }}
                    </button>
                </div>

                <div class="message-details-actions" *ngIf="canShowActiveMessageTraceAction()">
                    <button type="button"
                            class="message-details-trace-link"
                            [disabled]="activeMessageTraceLoading"
                            (click)="openActiveMessageTraceDetail($event)">
                        <i class="fa-solid fa-arrow-up-right-from-square"></i>
                        <span>{{ activeMessageTraceLoading ? 'Opening trace...' : 'Trace detail' }}</span>
                    </button>
                    <span class="message-details-trace-error" *ngIf="activeMessageTraceError">{{ activeMessageTraceError }}</span>
                </div>

                <ng-container [ngSwitch]="activeMessageDetailsTab">
                    <ng-container *ngSwitchCase="'usage'">
                        <div class="message-details-diagnostics" *ngIf="getActiveMessageCreditDebug() as creditDebug">
                            <div class="message-details-diagnostics__header">
                                <div class="message-details-diagnostics__copy">
                                    <span class="message-details-diagnostics__eyebrow">Usage attribution</span>
                                    <strong>{{ creditDebug.associationLabel }}</strong>
                                    <small>{{ creditDebug.associationHint }}</small>
                                </div>

                                <span class="message-details-diagnostics__badge" [class.message-details-diagnostics__badge--empty]="!creditDebug.hasCreditEvent">
                                    <ng-container *ngIf="creditDebug.hasCreditEvent; else noCreditsBadge">
                                        {{ formatCredits(creditDebug.totalCredits) }} credits
                                    </ng-container>
                                    <ng-template #noCreditsBadge>No recorded credits</ng-template>
                                </span>
                            </div>

                            <div class="message-details-diagnostics__grid" *ngIf="creditDebug.hasCreditEvent; else noCreditEventState">
                                <div class="message-details-diagnostics__card">
                                    <span class="message-details-diagnostics__label">Iteration</span>
                                    <strong>{{ creditDebug.iteration }}</strong>
                                    <small>{{ creditDebug.modelDisplayName }}</small>
                                </div>

                                <div class="message-details-diagnostics__card">
                                    <span class="message-details-diagnostics__label">Credits</span>
                                    <strong>{{ formatCredits(creditDebug.totalCredits) }}</strong>
                                    <small>Model {{ formatCredits(creditDebug.modelCredits) }} · Compute {{ formatCredits(creditDebug.computeCredits) }}</small>
                                </div>

                                <div class="message-details-diagnostics__card">
                                    <span class="message-details-diagnostics__label">Tokens</span>
                                    <strong>{{ creditDebug.totalTokens | number }}</strong>
                                    <small>In {{ creditDebug.inputTokens | number }} · Out {{ creditDebug.outputTokens | number }}</small>
                                </div>

                                <div class="message-details-diagnostics__card">
                                    <span class="message-details-diagnostics__label">Compute</span>
                                    <strong>{{ formatComputeDuration(creditDebug.computeSeconds, creditDebug.computeMilliseconds) }}</strong>
                                    <small>Total {{ formatCost(creditDebug.totalCostUsd) }} · Compute {{ formatCost(creditDebug.computeCostUsd) }}</small>
                                </div>
                            </div>

                            <ng-template #noCreditEventState>
                                <div class="message-details-diagnostics__empty">
                                    No credit event was matched to this message yet. Token usage may still be available below if the model response stored it directly.
                                </div>
                            </ng-template>
                        </div>

                        <div class="message-details-cost-footer" *ngIf="getActiveMessageCostBreakdown() as costBreakdown">
                            <div class="message-details-cost-heading">Token cost estimate</div>
                            <div class="message-details-cost-line">
                                <span>Input</span>
                                <strong>{{ formatCost(costBreakdown.inputCost, costBreakdown.currency) }}</strong>
                            </div>
                            <div class="message-details-cost-line">
                                <span>Output</span>
                                <strong>{{ formatCost(costBreakdown.outputCost, costBreakdown.currency) }}</strong>
                            </div>
                            <div class="message-details-cost-line message-details-cost-total">
                                <span>Total</span>
                                <strong>{{ formatCost(costBreakdown.totalCost, costBreakdown.currency) }}</strong>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'terminal'">
                        <div class="message-details-terminal">
                            <ng-container *ngIf="getActiveMessageTerminalSections() as terminalSections">
                                <ng-container *ngIf="terminalSections.length > 0; else terminalEmptyState">
                                    <div *ngFor="let section of terminalSections; trackBy: trackByTerminalHistorySection"
                                         class="message-details-terminal__section"
                                         [class.message-details-terminal__section--muted]="section.tone === 'muted'">
                                        <div class="message-details-terminal__header">
                                            <div class="message-details-terminal__copy">
                                                <span class="message-details-terminal__eyebrow">{{ section.eyebrow }}</span>
                                                <strong>{{ section.title }}</strong>
                                                <small *ngIf="section.subtitle">{{ section.subtitle }}</small>
                                            </div>
                                        </div>

                                        <pre class="message-details-terminal__output">{{ section.output }}</pre>
                                    </div>
                                </ng-container>
                            </ng-container>

                            <ng-template #terminalEmptyState>
                                <div class="message-details-terminal__empty">{{ getActiveMessageTerminalEmptyState() }}</div>
                            </ng-template>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                        <button type="button"
                                class="message-details-device-link"
                                *ngIf="canOpenActiveToolResultDeviceCommand()"
                                (click)="openActiveToolResultDeviceCommand($event)">
                            <i class="fa-regular fa-laptop-mobile"></i>
                            <span>Open this device command in Devices</span>
                        </button>

                        <button type="button"
                                class="message-details-device-link message-details-device-link--danger"
                                *ngIf="canDeleteActiveCompactionMarker()"
                                (click)="deleteActiveCompactionMarker($event)">
                            <i class="fa-regular fa-trash-can"></i>
                            <span>Delete compaction</span>
                        </button>

                        <pre>{{ getToolDetails(activeMessage) }}</pre>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </ng-template>

    <ng-template #minimalToolHistoryPopoverTemplate>
        <div class="minimal-tool-history-popover" *ngIf="activeMinimalToolHistoryItems.length > 0">
            <div *ngFor="let item of activeMinimalToolHistoryItems; trackBy: trackByMinimalToolHistoryItem"
                    class="minimal-tool-history-popover__item"
                    [class.minimal-tool-history-popover__item--active]="openPopoverIndex === item.index">
                <i [class]="getToolMessageIconClass(item.message)"></i>
                <span>{{ getMinimalToolHistoryItemLabel(item) }}</span>
            </div>
        </div>
    </ng-template>

    <ng-template #artifactPreviewTemplate>
        <div class="artifact-preview-modal"
             [class.artifact-preview-modal--detached]="usesDetachedPreviewSurface()"
             *ngIf="activeArtifact">
            <div *ngIf="!usesDetachedPreviewSurface()" class="artifact-preview-meta">
                <div class="artifact-preview-meta__path">{{ getArtifactLocationLabel(activeArtifact) }}</div>
                <div class="artifact-preview-meta__actions">
                    <a *ngIf="canLaunchArtifact(activeArtifact) && getArtifactLaunchHref(activeArtifact) as artifactLaunchHref"
                       class="artifact-preview-meta__link"
                       [href]="artifactLaunchHref"
                       target="_blank"
                       rel="noopener noreferrer">
                        Launch
                    </a>
                    <a *ngIf="getArtifactHostedHref(activeArtifact) as artifactHostedHref"
                       class="artifact-preview-meta__link"
                       [href]="artifactHostedHref"
                       target="_blank"
                       rel="noopener noreferrer">
                        Open file
                    </a>
                    <a *ngIf="getArtifactRawHref(activeArtifact) as artifactHref"
                       class="artifact-preview-meta__link"
                       [href]="artifactHref"
                       target="_blank"
                       rel="noopener noreferrer">
                        Open raw
                    </a>
                    <button *ngIf="shouldShowStandaloneArtifactDelete(activeArtifact)"
                            type="button"
                            class="artifact-preview-meta__link artifact-preview-meta__link--button artifact-preview-meta__link--danger"
                            [disabled]="isArtifactResourceDeleting(activeArtifact)"
                            (click)="deleteArtifactResource(activeArtifact, null, null, $event)">
                        <i class="fa-regular"
                           [ngClass]="isArtifactResourceDeleting(activeArtifact) ? 'fa-spinner fa-spin' : 'fa-trash-can'"></i>
                        <span>Delete</span>
                    </button>
                </div>
            </div>

            <div *ngIf="artifactPreviewLoading" class="artifact-preview-state">
                <div class="artifact-preview-state__loader" aria-hidden="true">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="artifact-preview-state__copy">
                    <strong>Loading preview</strong>
                    <span>Preparing the artifact view.</span>
                </div>
            </div>

            <div *ngIf="!artifactPreviewLoading && artifactPreviewError" class="artifact-preview-state artifact-preview-state--error">
                <i class="fa-regular fa-file-circle-xmark"></i>
                <span>{{ artifactPreviewError }}</span>
            </div>

                            <div *ngIf="!artifactPreviewLoading && !artifactPreviewError && artifactPreview as preview"
                                    class="artifact-preview-body"
                                    [class.artifact-preview-body--detached]="usesDetachedPreviewSurface()">
                                <div class="artifact-preview-toolbar" *ngIf="canEditArtifactRaw() && !usesDetachedPreviewSurface()">
                    <button type="button"
                            class="artifact-preview-toolbar__tab"
                            [class.artifact-preview-toolbar__tab--active]="artifactPreviewMode === 'preview'"
                            (click)="setArtifactPreviewMode('preview')">
                        Preview
                    </button>
                    <button type="button"
                            class="artifact-preview-toolbar__tab"
                            [class.artifact-preview-toolbar__tab--active]="artifactPreviewMode === 'raw'"
                            (click)="setArtifactPreviewMode('raw')">
                        Raw
                    </button>

                    <div class="artifact-preview-toolbar__status"
                         [ngClass]="getArtifactRawStatusClass()">
                        {{ getArtifactRawStatusLabel() }}
                    </div>
                </div>

                <div *ngIf="artifactPreviewMode === 'raw'" class="artifact-preview-raw">
                    <div *ngIf="artifactRawLoading" class="artifact-preview-state artifact-preview-state--compact">
                        <div class="artifact-preview-state__loader" aria-hidden="true">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        <div class="artifact-preview-state__copy">
                            <strong>Loading full file</strong>
                            <span>Fetching the editable source.</span>
                        </div>
                    </div>

                    <textarea *ngIf="!artifactRawLoading"
                              class="artifact-preview-editor"
                              [value]="artifactRawDraft"
                              (input)="onArtifactRawInput($event)"
                              spellcheck="false"
                              autocapitalize="off"
                              autocomplete="off"
                              autocorrect="off"></textarea>
                </div>

                <ng-container *ngIf="artifactPreviewMode === 'preview'">
                <div class="artifact-preview-notice" *ngIf="preview.truncated">
                    Showing a truncated preview of {{ preview.sizeBytes | number }} bytes.
                </div>

                <div *ngIf="preview.type === 'markdown'"
                     class="artifact-preview-markdown"
                     [innerHTML]="parseMarkdown(preview.content)">
                </div>

                <div *ngIf="preview.type === 'csv'" class="artifact-preview-csv">
                    <div *ngIf="getArtifactPreviewRows().length === 0" class="artifact-preview-state">
                        <span>This CSV is empty.</span>
                    </div>

                    <div *ngIf="getArtifactPreviewRows().length > 0" class="artifact-preview-table-wrap">
                        <table class="artifact-preview-table">
                            <thead>
                                <tr>
                                    <th *ngFor="let cell of getArtifactPreviewHeader()">{{ cell }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of getArtifactPreviewBody()">
                                    <td *ngFor="let cell of row">{{ cell }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <pre *ngIf="preview.type === 'text'"
                     class="artifact-preview-text"><code>{{ preview.content }}</code></pre>

                <div *ngIf="preview.type === 'html' || preview.type === 'svg'" class="artifact-preview-html-stage">
                    <app-html-previewer [html]="preview.content"
                                         [baseUrl]="preview.fileUrl || null">
                    </app-html-previewer>
                </div>

                <div *ngIf="preview.type === 'image'" class="artifact-preview-image-wrap">
                    <img *ngIf="preview.fileUrl"
                         class="artifact-preview-image"
                         [src]="preview.fileUrl"
                         [alt]="activeArtifact?.title || 'Artifact preview'">
                </div>

                <div *ngIf="preview.type === 'audio'" class="artifact-preview-media-wrap">
                    <audio *ngIf="preview.fileUrl"
                           class="artifact-preview-audio"
                           controls
                           preload="metadata"
                           [src]="preview.fileUrl">
                    </audio>
                </div>

                <div *ngIf="preview.type === 'video'" class="artifact-preview-media-wrap">
                    <video *ngIf="preview.fileUrl"
                           class="artifact-preview-video"
                           controls
                           preload="metadata"
                           [src]="preview.fileUrl">
                    </video>
                </div>

                <app-artifact-zip-preview *ngIf="preview.type === 'zip'"
                                          [archiveTitle]="activeArtifact?.title || 'ZIP archive'"
                                          [archiveUrl]="preview.fileUrl || null"
                                          [archiveStorageUri]="activeArtifact?.storageUri || null"
                                          [detachedPreview]="usesDetachedPreviewSurface()"
                                          [parseMarkdown]="parseMarkdown"
                                          (viewerStateChange)="onZipPreviewViewerStateChange($event)"
                                          (archiveSaved)="onZipArtifactSaved($event)"
                                          (archiveDeleted)="onZipArtifactDeleted(activeArtifact, null, null, $event)">
                </app-artifact-zip-preview>

                <div *ngIf="preview.type === 'file' && activeArtifact"
                     class="artifact-preview-file-card">
                    <i [class]="getThreadArtifactIconClass(activeArtifact)"></i>
                    <div class="artifact-preview-file-card__copy">
                        <strong>{{ activeArtifact.title }}</strong>
                        <span>{{ activeArtifact.subtitle || getArtifactLocationLabel(activeArtifact) }}</span>
                    </div>
                    <a *ngIf="preview.fileUrl"
                       class="artifact-preview-file-card__link"
                       [href]="preview.fileUrl"
                       target="_blank"
                       rel="noopener noreferrer">
                        Open file
                    </a>
                </div>
                </ng-container>
            </div>
        </div>
    </ng-template>

    <ng-template #artifactPreviewActionsTemplate>
        <div class="chat-preview-modal__header-actions" *ngIf="activeArtifact && artifactPreviewMode === 'raw' && !usesDetachedPreviewSurface()">
            <button type="button"
                    class="chat-preview-modal__button chat-preview-modal__button--primary"
                    [disabled]="!canSaveArtifactRaw()"
                    (click)="saveArtifactRaw()">
                <i *ngIf="artifactRawSaving" class="fa-solid fa-spinner fa-spin"></i>
                <i *ngIf="!artifactRawSaving" class="fa-regular fa-floppy-disk"></i>
                <span>Save</span>
            </button>
        </div>
    </ng-template>

    <ng-template #generatedImagePreviewTemplate>
        <div class="generated-image-preview-modal" *ngIf="activeGeneratedImage">
            <div class="generated-image-preview-stage">
                <img class="generated-image-preview-image"
                     [src]="activeGeneratedImage.url"
                     [alt]="activeGeneratedImage.altText || activeGeneratedImage.name || 'Generated image preview'">
            </div>

            <div class="generated-image-preview-meta">
                <div class="generated-image-preview-title">{{ activeGeneratedImage.name || 'Generated image' }}</div>
                <div class="generated-image-preview-subtitle">{{ getGeneratedImagePreviewSubtitle(activeGeneratedImage) }}</div>
                <div *ngIf="getGeneratedImagePreviewDetail(activeGeneratedImage) as detail" class="generated-image-preview-detail">{{ detail }}</div>
                <div *ngIf="getGeneratedImageAttribution(activeGeneratedImage) as attribution" class="generated-image-preview-attribution">{{ attribution }}</div>
                <button *ngIf="hasGeneratedImageSource(activeGeneratedImage)"
                        type="button"
                        class="generated-image-preview-source"
                        (click)="openGeneratedImageSource(activeGeneratedImage)">
                    <i class="fa-regular fa-arrow-up-right-from-square"></i>
                    <span>View source</span>
                </button>
            </div>
        </div>
    </ng-template>

    <ng-template #generatedImagePreviewActionsTemplate>
        <div class="chat-preview-modal__header-actions" *ngIf="activeGeneratedImage as media">
            <button type="button"
                    class="chat-preview-modal__button"
                    (click)="downloadGeneratedImage(media)">
                <i class="fa-regular fa-arrow-down-to-line"></i>
                <span>Download</span>
            </button>

            <button type="button"
                    class="chat-preview-modal__button"
                    (click)="openGeneratedImageInNewTab(media)">
                <i class="fa-regular fa-up-right-from-square"></i>
                <span>Open</span>
            </button>

            <button *ngIf="hasGeneratedImageSource(media)"
                    type="button"
                    class="chat-preview-modal__button"
                    (click)="openGeneratedImageSource(media)">
                <i class="fa-regular fa-link"></i>
                <span>Source</span>
            </button>
        </div>
    </ng-template>

    <ng-template #generatedAudioPreviewTemplate>
        <div class="generated-audio-preview-modal" *ngIf="activeGeneratedAudio as media">
            <div class="message-generated-audio-card message-generated-audio-card--preview">
                <audio #previewAudioPlayer
                       class="message-generated-audio-element"
                       [src]="media.url"
                       preload="metadata"
                       playsinline
                       (loadedmetadata)="onGeneratedAudioMetadataLoaded(media, previewAudioPlayer)"
                       (durationchange)="onGeneratedAudioMetadataLoaded(media, previewAudioPlayer)"
                       (timeupdate)="onGeneratedAudioTimeUpdate(media, previewAudioPlayer)"
                       (play)="onGeneratedAudioPlaybackStateChange(media, previewAudioPlayer, true)"
                       (pause)="onGeneratedAudioPlaybackStateChange(media, previewAudioPlayer, false)"
                       (ended)="onGeneratedAudioEnded(media, previewAudioPlayer)"
                       (ratechange)="onGeneratedAudioRateChange(media, previewAudioPlayer)"
                       (error)="onGeneratedAudioLoadError(media)"></audio>

                <div class="message-generated-audio-player">
                    <div class="message-generated-audio-controls">
                        <button
                            type="button"
                            class="message-generated-audio-play-toggle"
                            [attr.aria-label]="isGeneratedAudioPlaying(media) ? 'Pause audio' : 'Play audio'"
                            (click)="toggleGeneratedAudioPlayback(media, previewAudioPlayer)">
                            <i class="fa-solid" [class.fa-pause]="isGeneratedAudioPlaying(media)" [class.fa-play]="!isGeneratedAudioPlaying(media)"></i>
                        </button>

                        <div class="message-generated-audio-timeline">
                            <div class="message-generated-audio-time-row">
                                <span>{{ formatGeneratedAudioTime(getGeneratedAudioCurrentTime(media)) }}</span>
                                <span>{{ getGeneratedAudioDurationLabel(media) }}</span>
                            </div>

                            <input
                                type="range"
                                class="message-generated-audio-scrubber"
                                min="0"
                                step="0.01"
                                [max]="getGeneratedAudioDuration(media) || 1"
                                [value]="getGeneratedAudioCurrentTime(media)"
                                [disabled]="!hasGeneratedAudioDuration(media)"
                                [style.--audio-progress]="getGeneratedAudioProgressPercent(media)"
                                [attr.aria-label]="'Seek ' + (media.name || 'generated audio')"
                                (input)="onGeneratedAudioSeek(media, previewAudioPlayer, $any($event.target).value)">
                        </div>
                    </div>
                </div>

                <div class="message-generated-audio-meta">
                    <div class="message-generated-audio-name">{{ media.name || 'Generated audio' }}</div>

                    <div class="message-generated-audio-options">
                        <button
                            type="button"
                            class="message-generated-audio-menu-toggle"
                            [class.message-generated-audio-menu-toggle--open]="isGeneratedAudioMenuOpen(media)"
                            [attr.aria-expanded]="isGeneratedAudioMenuOpen(media)"
                            [attr.aria-label]="'Audio options for ' + (media.name || 'generated audio')"
                            (click)="openGeneratedAudioOptionsPopover(media, previewAudioPlayer, $event)">
                            <span>Options</span>
                            <i class="fa-solid fa-chevron-down"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #generatedAudioPreviewActionsTemplate>
        <div class="chat-preview-modal__header-actions" *ngIf="activeGeneratedAudio as media">
            <button type="button"
                    class="chat-preview-modal__button"
                    (click)="downloadGeneratedAudio(media)">
                <i class="fa-regular fa-arrow-down-to-line"></i>
                <span>Download</span>
            </button>

            <button type="button"
                    class="chat-preview-modal__button"
                    (click)="openGeneratedAudioInNewTab(media)">
                <i class="fa-regular fa-up-right-from-square"></i>
                <span>Open</span>
            </button>
        </div>
    </ng-template>

    <ng-template #generatedAudioOptionsPopoverTemplate>
        <div class="generated-audio-options-popover" *ngIf="activeGeneratedAudioPopover as media">
            <div class="generated-audio-options-popover__section">
                <div class="generated-audio-options-popover__label">Playback speed</div>

                <div class="generated-audio-options-popover__rate-list">
                    <button *ngFor="let rate of generatedAudioPlaybackRates"
                            type="button"
                            class="generated-audio-options-popover__rate-button"
                            [class.generated-audio-options-popover__rate-button--active]="isGeneratedAudioPlaybackRateSelected(media, rate)"
                            (click)="setActiveGeneratedAudioPlaybackRate(rate, $event)">
                        {{ rate }}x
                    </button>
                </div>
            </div>

            <button type="button"
                    class="generated-audio-options-popover__action"
                    (click)="downloadActiveGeneratedAudio($event)">
                <i class="fa-regular fa-arrow-down-to-line"></i>
                <span>Download</span>
            </button>

            <button *ngIf="usesDetachedPreviewSurface()"
                    type="button"
                    class="generated-audio-options-popover__action"
                    (click)="openActiveGeneratedAudioInSidePanel($event)">
                <i class="fa-regular fa-sidebar"></i>
                <span>{{ getGeneratedAudioPopoverPanelActionLabel(media) }}</span>
            </button>

            <div *ngIf="media.transcript"
                 class="generated-audio-options-popover__section">
                <div class="generated-audio-options-popover__label">Script</div>
                <div class="generated-audio-options-popover__script">{{ media.transcript }}</div>
            </div>
        </div>
    </ng-template>

    <ng-template #generatedImageOptionsPopoverTemplate>
        <div class="generated-image-options-popover" *ngIf="activeGeneratedImagePopover as media">
            <button type="button"
                    class="generated-image-options-popover__action"
                    (click)="downloadActiveGeneratedImage($event)">
                <i class="fa-regular fa-arrow-down-to-line"></i>
                <span>Download</span>
            </button>

            <button type="button"
                    class="generated-image-options-popover__action"
                    (click)="openActiveGeneratedImageInNewTab($event)">
                <i class="fa-regular fa-up-right-from-square"></i>
                <span>Open</span>
            </button>

            <button *ngIf="usesDetachedPreviewSurface()"
                    type="button"
                    class="generated-image-options-popover__action"
                    (click)="openActiveGeneratedImageInSidePanel($event)">
                <i class="fa-regular fa-sidebar"></i>
                <span>{{ getGeneratedImagePopoverPanelActionLabel(media) }}</span>
            </button>

            <button *ngIf="hasGeneratedImageSource(media)"
                    type="button"
                    class="generated-image-options-popover__action"
                    (click)="openActiveGeneratedImageSource($event)">
                <i class="fa-regular fa-link"></i>
                <span>Source</span>
            </button>
        </div>
    </ng-template>

    <ng-template #artifactSelectorPopoverTemplate>
        <div class="artifact-selector-popover" *ngIf="activeArtifactPopoverResources.length > 0">
            <div *ngFor="let artifact of activeArtifactPopoverResources; trackBy: trackByArtifact"
                 class="artifact-selector-popover__item"
                 [class.artifact-selector-popover__item--active]="isDetachedPreviewActive('artifact', artifact.id)">
                <button type="button"
                        class="artifact-selector-popover__item-open"
                        [attr.aria-pressed]="usesDetachedPreviewSurface() ? isDetachedPreviewActive('artifact', artifact.id) : null"
                        [title]="getArtifactPopoverItemStatusLabel(artifact)"
                        (click)="openArtifactResource(artifact, $event)">
                    <i class="fa-regular fa-file-lines"></i>
                    <span class="artifact-selector-popover__item-label">{{ artifact.title }}</span>
                </button>

                <button *ngIf="shouldShowArtifactSelectorDelete(artifact)"
                        type="button"
                        class="artifact-selector-popover__item-delete"
                        [title]="getArtifactDeleteLabel(artifact)"
                        [attr.aria-label]="getArtifactDeleteLabel(artifact)"
                        [disabled]="!canDeleteArtifactResource(artifact)"
                        (click)="deleteArtifactResource(artifact, null, null, $event)">
                    <i class="fa-regular"
                       [ngClass]="isArtifactResourceDeleting(artifact) ? 'fa-spinner fa-spin' : 'fa-trash-can'"></i>
                </button>

                <button *ngIf="usesDetachedPreviewSurface()"
                        type="button"
                        class="artifact-selector-popover__item-status"
                        [title]="getArtifactPopoverItemStatusLabel(artifact)"
                        (click)="openArtifactResource(artifact, $event)">
                    {{ getArtifactPopoverItemStatusLabel(artifact) }}
                </button>
            </div>
        </div>
    </ng-template>

    <ng-template #previewHeaderActionsTemplate>
        <div class="chat-preview-modal__header-actions" *ngIf="activePreviewResource as preview">
            <div *ngIf="canZoomPreview(preview)" class="chat-preview-modal__zoom-controls">
                <button type="button"
                        class="chat-preview-modal__zoom-button"
                        title="Zoom out"
                        (click)="decreasePreviewModalZoom()">
                    <i class="fa-solid fa-minus"></i>
                </button>

                <button type="button"
                        class="chat-preview-modal__zoom-readout"
                        title="Reset zoom"
                        (click)="resetPreviewModalZoom()">
                    {{ getActivePreviewZoomPercent() }}%
                </button>

                <button type="button"
                        class="chat-preview-modal__zoom-button"
                        title="Zoom in"
                        (click)="increasePreviewModalZoom()">
                    <i class="fa-solid fa-plus"></i>
                </button>
            </div>

            <a class="chat-preview-modal__button chat-preview-modal__button--ghost"
                    [href]="getPreviewLinkHref(preview)"
               target="_blank"
               rel="noopener noreferrer">
                <i class="fa-solid fa-arrow-up-right-from-square"></i>
                <span>Open</span>
            </a>
        </div>
    </ng-template>

    <ng-template #previewExpandedTemplate>
        <div class="chat-preview-modal" *ngIf="activePreviewResource as preview">
            <div class="chat-preview-modal__viewport"
                 [style.--preview-scale]="previewModalZoom">
                <iframe class="chat-preview-modal__frame"
                        [src]="preview.safeUrl"
                        [style.width]="getPreviewModalFrameWidth()"
                        [style.height]="getPreviewModalFrameHeight()"
                        allow="clipboard-write"
                        frameborder="0"
                        referrerpolicy="strict-origin-when-cross-origin"></iframe>
            </div>
        </div>
    </ng-template>
</div>
